
/**
 * Footer component
 * Updated: 2025-09-19 - Replaced logo with official Autaro logo and updated copyright text to Polish
 */
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-secondary text-gray-400 pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <img 
                src="/lovable-uploads/ab6b8a60-661c-497b-838f-bf64a57defac.png" 
                alt="Autaro Logo" 
                className="h-14" 
              />
            </div>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-white transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="hover:text-white transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="hover:text-white transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Szybkie linki</h3>
            <ul className="space-y-2">
              <li><a href="#hero" className="hover:text-white transition-colors">Wyceń Samochód</a></li>
              <li><Link to="/how-it-works" className="hover:text-white transition-colors">Jak to Działa</Link></li>
              <li><a href="#faq" className="hover:text-white transition-colors">Często zadawane pytania</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-2">
              <li className="text-gray-400">+48 45 9569800</li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Autaro dla komisów</h3>
            <ul className="space-y-2">
              <li><a href="https://aukcja.autaro.pl" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Platforma aukcyjna</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm mb-4 md:mb-0">
              © Autaro 2025. Wszelkie Prawa Zastrzeżone
            </div>
          <div className="flex space-x-4 text-sm">
            <Link to="/privacy" className="hover:text-white transition-colors">Polityka Prywatności</Link>
            <Link to="/privacy#cookies" className="hover:text-white transition-colors">Zarządzaj cookies</Link>
          </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
